export const VERIFY_TOKEN_REQUESTED = 'activation/VERIFY_TOKEN_REQUESTED';
export const VERIFY_TOKEN_SUCCESSED = 'activation/VERIFY_TOKEN_SUCCESSED';
export const VERIFY_TOKEN_FAILED = 'activation/VERIFY_TOKEN_FAILED';

export const USER_ACTIVATION_REQUESTED = 'activation/USER_ACTIVATION_REQUESTED';
export const USER_ACTIVATION_SUCCESSED = 'activation/USER_ACTIVATION_SUCCESSED';
export const USER_ACTIVATION_FAILED = 'activation/USER_ACTIVATION_FAILED';
